export enum HomeSlotType {
    MainBanner = 'mainBanner',
    UnderBanners = 'underBanners',
    Brandorama = 'brandorama',
    ProductsList = 'productsList',
    ProductRecommendations = 'productRecommendations',
    FastAccess = 'fastAccess',
    MobileButtons = 'mobileButtons',
    OpenBarServices = 'openBarServices',
    BeautyTips = 'beautyTips',
    TargetedCarousel = 'targetedCarousel',
}
